import { cacheRequests } from "../../utils/cacheRequests";
import { GetOrderRequestDetailsRequest } from "./order-request/GetOrderRequestDetailsRequest";
import { GetOrderRequestDetailsResponse } from "./order-request/GetOrderRequestDetailsResponse";
import { useOrdersRequestsApi } from "./useOrderRequestsApi";

const getOrderRequestDetailsCache = cacheRequests<GetOrderRequestDetailsResponse>();

export const useCachedOrderRequestsApi = () => {
    const { getOrderRequestDetails } = useOrdersRequestsApi();

    const ttlMs = 20000;

    const getCachedOrderRequestDetails = async (
        request: GetOrderRequestDetailsRequest
    ): Promise<GetOrderRequestDetailsResponse> => {
        return getOrderRequestDetailsCache.getRequest({
            requestFn: () => getOrderRequestDetails(request),
            key: `order-request-details-${request.orderRequestId}`,
            ttlMs
        });
    };

    return {
        getOrderRequestDetails: getCachedOrderRequestDetails
    };
};
